import * as Cookies from 'js-cookie';
import axios from 'axios';

// Put token into memory
let token: string | undefined;

// Set the token name
export const tokenName = process.env.REACT_APP_TARGET === 'prod' ? 'token' : `${process.env.REACT_APP_TARGET}-token`;

export const cookieOptions = {
  // domain: process.env.REACT_APP_TARGET !== 'local' ? 'nkba.org' : undefined,
  domain:
    process.env.REACT_APP_TARGET !== 'local'
      ? process.env.REACT_APP_TARGET === 'dev-new'
        ? 'nkba.us'
        : 'nkba.org'
      : undefined,
  secure: process.env.REACT_APP_TARGET !== 'local',
};

export const getToken = () => {
  return typeof window !== 'undefined' ? Cookies.get(tokenName) : undefined;
};

// Important! Try to load the cookie when the page loads
token = getToken();

export const setToken = (t: string) => {
  Cookies.set(tokenName, t);
  // update token in mem
  token = getToken();
};

const apiAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiAxios.interceptors.request.use(request => {
  if (!token) {
    return request;
  } else {
    return {
      ...request,
      headers: { ...request.headers, Authorization: `Bearer ${token}` },
    };
  }
});

apiAxios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error && error.response && error.response.status === 401) {
      window.localStorage.removeItem(tokenName); // clear legacy stuff.
      Cookies.remove(tokenName, cookieOptions);
      window.location.replace(
        `${process.env.REACT_APP_WEB_URL}/login?redirect=${encodeURIComponent(window.location.href)}`
      );
    }
    // Do something with request error
    return Promise.reject(error);
  }
);

export { apiAxios as axios };



// WEBPACK FOOTER //
// ./src/common/api/axios.config.ts